import axios from 'axios';
// import { serviceUserJwt } from './serviceConfig';

export async function userLogin(payload) {
  let uploadResponse = {};
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/security_api/security/login';
    console.log('ENV REACT_APP_BACKEND_URL', window.env.REACT_APP_BACKEND_URL);
    console.log('Security URL', url);
    await axios
      .post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          // Authorization: serviceUserJwt,
        },
      })
      .then((response) => {
        uploadResponse = response;
      });
  } catch (ex) {
    console.log('Error', ex.message);
    uploadResponse.error = ex.response.data;
  }
  return uploadResponse;
}

export async function userLogout(data) {
  let getDoctypeResponse = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + '/security_api/security/logout';

    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        getDoctypeResponse = response;
      });
  } catch (ex) {
    console.log('Error in getDoctype.js getDoctype()', ex.message);
  }

  return getDoctypeResponse;
}

export const fetchBuowInfo = async (data) => {
  let getbuowInfo = [];
  try {
    const url = window.env.REACT_APP_BACKEND_URL + `/buow_api/in_baskets/buow/${data?.buow}`;
    await axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        getbuowInfo = res;
      });
  } catch (err) {
    console.log(err, 'Error in fetching buow details');
  }
  return getbuowInfo;
};
